import { faCirclePlus } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const placeholderButtonClass =
  'vai-flex vai-min-h-[214px] vai-min-w-0 vai-flex-1 vai-cursor-pointer vai-flex-col vai-items-center vai-justify-center vai-gap-4 vai-rounded-lg vai-border vai-border-dashed vai-border-zinc-200 vai-bg-zinc-50 vai-p-4 vai-text-left hover:vai-bg-zinc-100/80 focus-visible:vai-outline-none focus-visible:vai-ring-2 focus-visible:vai-ring-ring focus-visible:vai-ring-offset-2';

export interface SetCriteriaPlaceholderProps {
  message: string;
  onClick?: () => void;
}

export function SetCriteriaPlaceholder({
  message,
  onClick,
}: SetCriteriaPlaceholderProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={placeholderButtonClass}
    >
      <div className="vai-flex vai-h-8 vai-w-8 vai-items-center vai-justify-center">
        <FontAwesomeIcon
          icon={faCirclePlus}
          className="vai-text-[32px] vai-text-zinc-300"
        />
      </div>
      <p className="vai-text-center vai-text-base vai-leading-6 vai-text-muted-foreground">
        {message}
      </p>
    </button>
  );
}
